module.exports = function () {
	$('body').on('click', '.product-tile .swatch', function (e) {
		var currentswatch = $(e.target);
		if (!currentswatch.parents('.swatch-click').hasClass('selected')) {
			//proceed only for new swatch selection

			var alternateImg = $(this).attr('data-swatch-details');
			let imagePreset = $(this).attr('data-image-preset');
			var ast = JSON.parse(alternateImg);
			var newurl = ast[0].absURL;
			if (imagePreset) {
				newurl += newurl.indexOf('?') > -1 ? '&' + imagePreset : '?' + imagePreset;
			}
			
			var currentParent = currentswatch.parents('.product-tile');
			var imgContainer = $(currentParent).children('.image-container').children('a');
			let pdpLinkContainer = $(currentParent).find('.pdp-link').children('a');
			var mainHref = currentswatch.parents('.swatch-click').data('href');
			var seeMore = $(currentParent).find('.anchorfont');
			imgContainer.attr('href', mainHref);
			pdpLinkContainer.attr('href', mainHref);
			imgContainer.children('img').attr('src', newurl);
			currentswatch.parents('.swatches').find('.swatch-click.selected').removeClass('selected');
			currentswatch.parents('.swatch-click').addClass('selected');
			if (currentswatch.parents('.swatch-click').find('.variationame')) {
				let variantionName = currentswatch.parents('.swatch-click').find('.variationame').text();
				let $productClicklink = currentParent.find('.product-click-track');
				let gtmData = JSON.parse($productClicklink.attr('data-gtm-data'));
				gtmData.variant = $.trim(variantionName);
				$productClicklink.attr('data-gtm-data', JSON.stringify(gtmData));
			}
			var isRecommendation = $(currentParent).find('.pdp-link').data('recommendation-href');
			isRecommendation = (isRecommendation) ? isRecommendation : '';
			// Update tile pdp url based on swatch variation selection
			var swatchPDPUrl = $(this).data('pdp-url');
			var analyticsURL = swatchPDPUrl + isRecommendation;
			$(this).parents('.product-tile').find('.product-click-track').attr('href', analyticsURL);

			// Tile specific PDP link updates
			var pdpLink1 = $(this).parents('.product-tile').find('a.product-click-track');
			var pdpLink2 = $(this).parents('.product-tile').find('.pdp-link a.link');
			$(pdpLink1).attr('href', swatchPDPUrl);
			$(pdpLink2).attr('href', swatchPDPUrl);
			if(seeMore && seeMore.length > 0){
				seeMore.attr('href',swatchPDPUrl);
			}

			// Update tile price based on swatch selection
			var swatchUpdateUrl = $(this).data('swatch-update');
			if (swatchUpdateUrl) {				
				var tilePrice = $(this).parents('.product').find('.price');
				var tileImage = $(this).parents('.product').find('.image-container .tile-image');
				$.spinner().start();
				$.ajax({
					url: swatchUpdateUrl,
					method: 'GET',
					success: function (response) {
						$(tilePrice).find('.price-starts').hide().parent().css('line-height','unset');
						if (response.price) {
							$(tilePrice).find('.value').attr('content', response.price.sales.decimalPrice).text(response.price.sales.formatted);
							$(tileImage).attr('src', response.image);
						}

						if (response.webBrowseOption == 'webGemstone' && $('.filter-bar .filter-value').length > 0) {
							// For Gemstone products, tile image cannot be retrieved based on metal selection
							// alone. Hence we`ll have to show variant image
							// Tile specific PDP link updates
							$(pdpLink1).attr('href', response.productUrl);
							$(pdpLink2).attr('href', response.productUrl);
							if(seeMore && seeMore.length > 0){
								seeMore.attr('href', response.productUrl);
							}
						}

						$.spinner().stop();
					},
					error: function () {
						$.spinner().stop();
					}
				});
			}

		}
	});
};